export default __webpack_public_path__ + "static/media/trustflight-logo-white.60ca034c.svg";